import { render, staticRenderFns } from "./HoldingTab.vue?vue&type=template&id=06255fde&scoped=true"
import script from "./HoldingTab.vue?vue&type=script&lang=js"
export * from "./HoldingTab.vue?vue&type=script&lang=js"
import style0 from "./HoldingTab.vue?vue&type=style&index=0&id=06255fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06255fde",
  null
  
)

export default component.exports